import "./styles.css";

const Cart = ({ currentSale, cartTotal, resetCart, removeItemCart }) => {
  return currentSale.length === 0 ? (
    <div id="div-carrinho-vazio">
      <div className="carrinho-header">
        <h3 className="titulo-carrinho-header">Carrinho de Compras</h3>
      </div>
      <div id="carrinho-vazio">
        <p id="carrinho-vazio-texto1">Sua sacola está vazia</p>
        <p id="carrinho-vazio-texto2">Adicione itens</p>
      </div>
    </div>
  ) : (
    <div id="div-carrinho-cheio">
      <div className="carrinho-header">
        <h3 className="titulo-carrinho-header">Carrinho de Compras</h3>
      </div>
      <div id="carrinho-cheio">
        <ul id="ul-carrinho">
          {currentSale.map((product) => (
            <li key={product.id} className="li-carrinho">
              <div className="div-img-carrinho">
                <img
                  className="img-carrinho"
                  src={product.img}
                  alt="imageCarrinho"
                ></img>
              </div>
              <div className="div-title-category">
                <h3 className="title-carrinho">{product.name}</h3>
                <p className="category-carrinho">{product.category}</p>
              </div>
              <span
                className="span-card"
                onClick={() => removeItemCart(product)}
              >
                Remover
              </span>
            </li>
          ))}
        </ul>
      </div>
      <div id="carrinho-total">
        <div id="div-spans">
          <span id="total">Total</span>
          <span id="valor">{cartTotal.toFixed(2)}</span>
        </div>
        <button id="button-carrinho-remover" onClick={resetCart}>
          Remover Todos
        </button>
      </div>
    </div>
  );
};

export default Cart;
